import type { StaticEntityType } from "@config";
import { Set } from "@library-containers/layers";
import "../styles/index.scss";

export const SideBySideLibrary = ({ entity }: { entity: StaticEntityType }) => {
  const { children, settings, id } = entity;

  return (
    <div className="combo sideBySideCombo tw-flex tw-w-full tw-flex-col">
      {children.map((child, index) => (
        <Set
          key={child.id}
          entity={{
            ...child,
            layers: {
              ...(entity.layers || {}),
              combo: { settings, index, id },
            },
          }}
        />
      ))}
    </div>
  );
};
